<div fxLayout="row" fxLayoutAlign="start ">
  <div fxFlex="1 0 auto">
    <h1>Communities</h1>
  </div>
  <div fxFlex="0 0 auto" fxLayoutGap="15px" fxFlexAlign="center">
    <a [routerLink]="['new']" mat-flat-button color="primary">New Community</a>
    <a
      *ngIf="admin$ | async"
      [routerLink]="['import']"
      mat-flat-button
      color="primary"
      >Bulk Import Communities</a
    >
  </div>
</div>
<mat-form-field class="searchField">
  <input matInput type="text" placeholder="Search" [(ngModel)]="search" />
  <button
    mat-button
    *ngIf="search.length > 0"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="search = ''"
  >
    <mat-icon>close</mat-icon>
  </button>
  <mat-hint align="start">Filter communities by first or last name</mat-hint>
</mat-form-field>
<bar-loader [loading]="loading$ | async"></bar-loader>
<data-list-table
  [config]="tableConfig"
  [link]="true"
  [dataSource]="customers"
  [sort]="(filter$ | async).order"
  [page]="page$ | async"
  (onSort)="sort($event)"
  (onPage)="paginate($event)"
></data-list-table>
